<mat-expansion-panel [expanded]="true" class="expansion-panel mat-elevation-z0" #filterPanel="matExpansionPanel"
                     togglePosition="before">
  <mat-expansion-panel-header class="expansion-panel__header">
    <mat-panel-title class="expansion-panel__title-wrapper">
      <div class="expansion-panel__title">
        {{title}}
        <button *ngIf="currentValue" mat-button
                type="button"
                class="expansion-panel__clear"
                (click)="onClearClick($event)"
        >
          Clear
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </div>
      <div *ngIf="!filterPanel.expanded && currentValue" class="expansion-panel__value">
        {{currentValue}}
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
